import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from '../../../_metronic/_partials/controls';

import { ListHeaderToolbar as HeaderToolbar } from '../../components/common/HeaderToolbar';
import { DataTableLocal as DataTable } from '../../components/common/DataTable';
import { fetchAnimalTypeList } from '../../../redux/animalType/list';

const AnimalListPage = () => {
  // Prereq Hooks
  const dispatch = useDispatch();

  // Initial fetch
  useEffect(() => {
    dispatch(fetchAnimalTypeList());
  }, []);

  const { data } = useSelector(state => state.animalType.list);
  const isFetching = useSelector(state => state.loading.animalType?.list);

  const columns = [
    {
      dataField: 'animal_name',
      text: 'Name'
    },
    {
      dataField: 'animal_category.category_name',
      text: 'Category'
    }
  ];

  return (
    <Card>
      <CardHeader title="Animal Type List">
        <CardHeaderToolbar>
          <HeaderToolbar addLink="/animalType/add" addText="New Type" />
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <DataTable
          data={data}
          loading={isFetching}
          totalDataCount={data.length}
          columns={columns}
          editLink="/animalType/"
        />
      </CardBody>
    </Card>
  );
};

export default AnimalListPage;
